import React from 'react';
import { Shield, Map, Users, Compass, Clock, Anchor } from 'lucide-react';
import { SectionHeader, PremiumCard } from './ui';
export function WhyNoronha() {
  const features = [{
    icon: Shield,
    title: 'Santuario Marino Protegido',
    description: 'Un parque nacional con regulaciones estrictas que garantizan una vida salvaje intacta y corales vibrantes.'
  }, {
    icon: Map,
    title: 'Top 3 Mundial',
    description: 'Considerado consistentemente como uno de los mejores destinos de buceo del mundo por su visibilidad y biodiversidad.'
  }, {
    icon: Users,
    title: 'Exclusividad Absoluta',
    description: 'Acceso limitado de turistas por día a la isla, asegurando inmersiones sin multitudes y playas desiertas.'
  }];
  return <section id="viaje" className="py-24 md:py-32 bg-noronha-volcanic relative" data-id="element-150">
      <div className="container mx-auto px-6" data-id="element-151">
        <SectionHeader eyebrow="El Destino" title="¿Por qué Noronha?" description="Un archipiélago volcánico en medio del Atlántico donde las reglas las dicta la naturaleza." className="mb-16" data-id="element-152" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-153">
          {features.map((feature, idx) => <PremiumCard key={idx} delay={idx * 0.1} data-id="element-154">
              <feature.icon className="w-10 h-10 text-noronha-emerald mb-6" strokeWidth={1.5} data-id="element-155" />
              <h3 className="text-xl font-heading text-noronha-text-heading mb-3" data-id="element-156">
                {feature.title}
              </h3>
              <p className="text-noronha-text-body leading-relaxed" data-id="element-157">
                {feature.description}
              </p>
            </PremiumCard>)}
        </div>
      </div>
    </section>;
}
export function WhatMakesItDifferent() {
  const differences = [{
    icon: Compass,
    title: 'Conocimiento Local',
    description: 'Guiados por expertos que conocen cada corriente, cada cueva y el comportamiento de la fauna local.'
  }, {
    icon: Clock,
    title: 'Ritmo de Expedición',
    description: 'Sin prisas comerciales. Nos enfocamos en buscar la mejor luz, las mejores condiciones y el momento perfecto.'
  }, {
    icon: Anchor,
    title: 'Grupo Reducido',
    description: 'Máximo 12 personas. Una experiencia íntima que nos permite movernos con agilidad y flexibilidad total.'
  }];
  return <section className="py-24 md:py-32 bg-noronha-graphite/30 border-y border-noronha-petroleum/20" data-id="element-158">
      <div className="container mx-auto px-6" data-id="element-159">
        <SectionHeader eyebrow="Nuestra Filosofía" title="¿Qué hace diferente este viaje?" description="No vendemos paquetes turísticos. Diseñamos expediciones para buceadores apasionados." className="mb-16" data-id="element-160" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-161">
          {differences.map((diff, idx) => <PremiumCard key={idx} delay={idx * 0.1} className="bg-noronha-volcanic" data-id="element-162">
              <diff.icon className="w-10 h-10 text-noronha-gold mb-6" strokeWidth={1.5} data-id="element-163" />
              <h3 className="text-xl font-heading text-noronha-text-heading mb-3" data-id="element-164">
                {diff.title}
              </h3>
              <p className="text-noronha-text-body leading-relaxed" data-id="element-165">
                {diff.description}
              </p>
            </PremiumCard>)}
        </div>
      </div>
    </section>;
}
export function TopReasons() {
  const reasons = [{
    num: '01',
    title: 'Paisaje Volcánico Submarino',
    desc: 'Cañones, cuevas y formaciones de lava solidificada únicas en el mundo.'
  }, {
    num: '02',
    title: 'Delfines Rotadores',
    desc: 'Encuentros cercanos con la colonia residente más grande del mundo.'
  }, {
    num: '03',
    title: 'Visibilidad Épica',
    desc: 'Aguas cristalinas que superan los 40 metros de visibilidad horizontal.'
  }, {
    num: '04',
    title: 'Naufragio Corveta V17',
    desc: 'Uno de los pecios más intactos y espectaculares del Atlántico Sur.'
  }, {
    num: '05',
    title: 'Desconexión Total',
    desc: 'Un entorno salvaje donde el ritmo lo marca la salida y puesta del sol.'
  }];
  return <section className="py-24 md:py-32 bg-noronha-volcanic" data-id="element-166">
      <div className="container mx-auto px-6" data-id="element-167">
        <SectionHeader eyebrow="Highlights" title="Top 5 razones para viajar" className="mb-16" data-id="element-168" />

        <div className="flex flex-col gap-4 max-w-4xl mx-auto" data-id="element-169">
          {reasons.map((reason, idx) => <PremiumCard key={idx} delay={idx * 0.1} className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-8 p-6 md:p-6" data-id="element-170">
              <span className="font-mono text-4xl md:text-5xl text-noronha-petroleum font-light" data-id="element-171">
                {reason.num}
              </span>
              <div data-id="element-172">
                <h3 className="text-xl font-heading text-noronha-text-heading mb-2" data-id="element-173">
                  {reason.title}
                </h3>
                <p className="text-noronha-text-body" data-id="element-174">{reason.desc}</p>
              </div>
            </PremiumCard>)}
        </div>
      </div>
    </section>;
}